/** QL-375 — the "Permitted allocation" box. Read with `useT(T)`. */
export const T = {
  en_GB: {
    bandDefault: "default",
    heldAtBank: "held at the bank, cannot be bought",
    legendCombined: "Combined weight across the goal's portfolios",
    legendDefault: "Mandate default",
    legendRange: "Permitted range",
    legendThisPortfolio: "This portfolio's weight",
    legendWeight: "Weight",
    linesTitle: "Permitted allocation",
    notHeld: "not held",
    unholdableInactive: "product inactive",
    unholdableNoIsin: "no ISIN, cannot be held in advice",
    unholdableNoProduct: "no product carries this ISIN",
    unholdableNotOnPlatform: "not on the goal's platform",
    unlistedTitle: "Outside the mandate",
    unmatchedHoldings: "Unmatched holdings",
  },
  nb_NO: {
    bandDefault: "standard",
    heldAtBank: "eid i banken, kan ikke kjøpes",
    legendCombined: "Samlet vekt over målets porteføljer",
    legendDefault: "Mandatets standard",
    legendRange: "Tillatt intervall",
    legendThisPortfolio: "Denne porteføljens vekt",
    legendWeight: "Vekt",
    linesTitle: "Tillatt allokering",
    notHeld: "ikke eid",
    unholdableInactive: "produktet er inaktivt",
    unholdableNoIsin: "ingen ISIN, kan ikke eies i råd",
    unholdableNoProduct: "ingen produkter har denne ISIN-en",
    unholdableNotOnPlatform: "ikke på målets plattform",
    unlistedTitle: "Utenfor mandatet",
    unmatchedHoldings: "Umatchede beholdninger",
  },
} as const;
